var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 4.66667V10C5.33317 10.3536 5.47365 10.6928 5.7237 10.9428C5.97374 11.1929 6.31288 11.3333 6.6665 11.3333H10.6665M5.33317 4.66667V3.33333C5.33317 2.97971 5.47365 2.64057 5.7237 2.39052C5.97374 2.14048 6.31288 2 6.6665 2H9.72384C9.90063 2.00004 10.0702 2.0703 10.1952 2.19533L13.1378 5.138C13.2629 5.263 13.3331 5.43254 13.3332 5.60933V10C13.3332 10.3536 13.1927 10.6928 12.9426 10.9428C12.6926 11.1929 12.3535 11.3333 11.9998 11.3333H10.6665M5.33317 4.66667H3.99984C3.64622 4.66667 3.30708 4.80714 3.05703 5.05719C2.80698 5.30724 2.6665 5.64638 2.6665 6V12.6667C2.6665 13.0203 2.80698 13.3594 3.05703 13.6095C3.30708 13.8595 3.64622 14 3.99984 14H9.33317C9.68679 14 10.0259 13.8595 10.276 13.6095C10.526 13.3594 10.6665 13.0203 10.6665 12.6667V11.3333",
    stroke: "#6B7280",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3061f97cdd1916ceaa392508bc123e12.svg";
export { ForwardRef as ReactComponent };